import { useEffect } from 'react';
import { collaborateNativeToWeb } from './bridge';
import { MessagesTypes } from './types';
import type { NativeToWebMessage } from './types';

export const useCollaborateBridgeListener = <
  T extends (typeof MessagesTypes)[keyof typeof MessagesTypes],
>(
  messageType: T,
  callback: (data: Extract<NativeToWebMessage, { type: T }>) => void,
) => {
  useEffect(() => {
    const unsubscribe = collaborateNativeToWeb.subscribe((message) => {
      if (message.type === messageType) {
        callback(message as Extract<NativeToWebMessage, { type: T }>);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [messageType, callback]);
};
